<template>
  <EasyDataTable
    :headers="scaleFields"
    :items="scaleContents"
    :alternating="true"
    :rows-per-page="10000"
    :hide-rows-per-page="true"
  >
    <template #item-languages="item">
      <span v-for="content in item.contents" :key="content.countryCode">
        <span :class="'flagItem flag-icon flag-icon-' + content.countryCode"></span>
      </span>
    </template>
    <template #item-selected="item">
      <b-form-checkbox v-model="item.selected">
      </b-form-checkbox>
    </template>
    <template #item-buttons="item">
      <b-button
                @click.stop="$emit('beforeEditScale', item.scale)"
                size="sm"
                class="fa fa-edit"
                v-if="allowEdit">
      </b-button>
      <b-form-checkbox v-else v-model="item.selected">
      </b-form-checkbox>
    </template>
  </EasyDataTable>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'scale-table',
  props: {
    scales: {},
    allowEdit: false
  },
  computed: {
    ...mapGetters(['selectedCulture']),
    scaleContents: function() {
      let items = []
      let langCode = this.selectedCulture.langCode

      if (this.scales.constructor === Array) {
        this.scales.forEach(scale => {
          let item = {
            scale: scale,
            name: '',
            questionFormat: scale.questionFormat,
            contents: [],
            creditCost: scale.creditCost,
            selected: scale.selected
          }

          if (scale.contents) {
            scale.contents.forEach(translation => {
              if (!item.name || translation.langCode === langCode) {
                item.name = translation.name
              }

              item.contents.push({
                languageId: translation.languageId,
                countryCode: translation.countryCode
              })
            })
          }

          items.push(item)
        })
      }
      return items
    },

    scaleFields() {
      var fields = [
        { value: 'name', text: this.$t('name'), sortable: true },
        {
          value: 'questionFormat',
          text: this.$t('privatePage.questionFormat_header'),
          sortable: true
        },
        { value: 'languages', text: this.$t('lang') },
        {
          value: 'creditCost',
          text: this.$t('privatePage.creditCost_header'),
          sortable: true
        }
      ]

      if (this.allowEdit) {
        fields.push({
          value: 'buttons',
          text: ' ',
          tdClass: 'rightAlignedField'
        })
      } else {
        fields.push({
          value: 'selected',
          text: this.$t('privatePage.isActive'),
          sortable: true
        })
      }

      return fields
    }
  }
}
</script>

<style scoped>
.flagItem {
  margin-right: 2px;
}
</style>
